/** Takes an array or string and returns the last element of it */
export const last = <T>(arr: T[] | string) => arr[arr.length - 1];
